import {TagsService} from '../../libs/ui/src';
import {client} from '../apiService';

const _TagsService = new TagsService({client});

export {_TagsService as TagsService};
